<div class="select-checkbox" (click)="$event.stopPropagation()">
  <div *ngFor="let userGroup of userGroupOptions">
    <mat-checkbox [checked]="groupControl.value.includes(userGroup)" (change)="toggleSelection(userGroup)">
      {{ userGroup.value }}
    </mat-checkbox>
  </div>
  <div class="action-buttons">
    <button mat-button color="primary" class="fx--mr-sm" [disabled]="!groupControl.dirty" (click)="cancelChanges()">
      {{ 'core.cancel' | xTranslate | uppercase }}
    </button>
    <button mat-flat-button color="primary" [disabled]="!groupControl.dirty" (click)="saveChanges()">
      {{ 'core.submit' | xTranslate | uppercase }}
    </button>
  </div>
</div>
